/*
saikrishna 10/04/2022 2698754100 Client and role bugs fixed
*/

import React, {useEffect, useContext} from 'react';
import {useForm} from 'react-hook-form';
import {useSelector, useDispatch} from 'react-redux';
import {TextField, FormControl, Button, FormHelperText} from '@material-ui/core';
import {Controller} from 'react-hook-form';
import {
  postClientContact,
  putClientContact,
  resetMessage,
  resetStatus,
} from '../../../../redux/reducers/client-maintainance/ClientContact';
import {useLocation} from 'react-router';
import PageLoader from '../../../../components/PageLoader';
import formatPhoneNumber from '../../../../util/PhoneFormat';
import {CONTACT_TYPE} from '../../../../constants/Lookup';
import * as Yup from 'yup';
import {yupResolver} from '@hookform/resolvers/yup';
import {PhoneMaskCustom} from '../../../../util/PhoneMaskFormat';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import GuiAutoComplete from '../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../components/FormComponents/GuiTextField';
const ClientContactForm = ({rowData, isEditMode, handleClose}) => {
  const {clientContactStatus, isLoading, dropDownData} = useSelector(
    ({clientContact}) => clientContact,
  );

  const getOptions = (typeCode) => {
    let label = [];
    label = dropDownData && dropDownData[typeCode] ? dropDownData[typeCode] : [];

    return label;
  };
  const getObject = (option, typeCode) => {
    const options = dropDownData && dropDownData[typeCode] ? dropDownData[typeCode] : [];

    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.value === option) {
          label = item;
        }
      });
    return label;
  };
  const initialValues = {
    contactType: rowData?.contactType ? getObject(rowData.contactType, CONTACT_TYPE) : {},
    contactName: rowData?.contactName ? rowData.contactName : '',
    contactPhoneNumber: rowData?.contactPhoneNumber ?
      formatPhoneNumber(rowData.contactPhoneNumber) :
      '',
    contactEmailAddress: rowData?.contactEmailAddress ? rowData.contactEmailAddress : '',
    contactFaxNumber: rowData?.contactFaxNumber ? formatPhoneNumber(rowData.contactFaxNumber) : '',
  };
  const validationSchema = Yup.object().shape({
    contactType: Yup.object()
      .test('contactType', 'Contact Type is required', (val) => {
        return val?.value;
      })
      .nullable(),
    contactName: Yup.string()
      .required('Name is required')
      .trim('The contact name cannot include leading and trailing spaces')
      .max(50, 'Name cannot exceed 50 characters'),
    contactEmailAddress: Yup.string().required('Email is required').email('Email is invalid'),

    contactPhoneNumber: Yup.string().test('phone', 'Invalid Phone Number', (value) => {
      value = value && value.replace(/[^\d]/g, '');
      if ((value && /^(\d)(?!\1+$)\d{9}$/.test(value)) || !value) {
        return true;
      }
    }),
    contactFaxNumber: Yup.string().test('phn', 'Invalid Fax Number', (value) => {
      value = value && value.replace(/[^\d]/g, '');
      if ((value && /^(\d)(?!\1+$)\d{9}$/.test(value)) || !value) {
        return true;
      }
    }),
  });
  const dispatch = useDispatch();
  const location = useLocation();
  const clientNumber = location?.state?.clientNumber;
  const {register, handleSubmit, errors, control, setValue, reset} = useForm({
    mode: 'all',
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const onSubmit = (data) => {
    if (data && clientNumber && !isEditMode) {
      dispatch(
        postClientContact({
          clientNumber: clientNumber,
          contactType: data?.contactType?.value ? data?.contactType?.value : '',
          contactName: data.contactName.trim() || '',
          contactPhoneNumber: data?.contactPhoneNumber ?
            Number(data.contactPhoneNumber.replace(/[^\d]/g, '')) :
            null,
          contactEmailAddress: data.contactEmailAddress || '',
          contactFaxNumber: data?.contactFaxNumber ?
            Number(data.contactFaxNumber.replace(/[^\d]/g, '')) :
            null,
        }),
      );
    } else if (clientNumber && isEditMode && data) {
      dispatch(
        putClientContact({
          clientNumber: clientNumber,
          clntContactId: rowData?.clntContactId || '',
          contactType: data?.contactType?.value ? data?.contactType?.value : '',
          contactName: data.contactName || '',
          contactPhoneNumber: data?.contactPhoneNumber ?
            Number(data.contactPhoneNumber.replace(/[^\d]/g, '')) :
            null,
          contactEmailAddress: data.contactEmailAddress || '',
          contactFaxNumber: data?.contactFaxNumber ?
            Number(data.contactFaxNumber.replace(/[^\d]/g, '')) :
            null,
        }),
      );
    }
  };
  useEffect(() => {
    if (clientContactStatus === 200) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 3000);
      dispatch(resetStatus());
      handleClose();
    }
  }, [clientContactStatus]);
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className="col-md-12">
          <div className="form-row">
            <div className="col-md-4 col-sm-6 form-group">
              <FormControl margin="dense" variant="outlined" fullWidth>
                <Controller
                  required
                  render={(props) => (
                    <GuiAutoComplete
                      {...props}
                      classes={{
                        option: classes.option,
                      }}
                      id="contactType"
                      options={getOptions(CONTACT_TYPE)}
                      size="small"
                      autoHighlight
                      getOptionDisabled={(option) => option.value === null}
                      getOptionLabel={(option) => {
                        return option.key === 'none' ? option.value : option.value;
                      }}
                      renderInput={(params) => (
                        <GuiTextField
                          className={`${classes.labelName} ${classes.selectLabel}`}
                          {...params}
                          variant="outlined"
                          fullWidth
                          label="Contact Type"
                          required
                          error={errors && errors?.contactType?.message}
                          name="contactType"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          placeholder="Select Contact Type"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off', // disable autocomplete and autofill
                          }}
                        />
                      )}
                      onChange={(_, data) => {
                        props.onChange(data);
                      }}
                    />
                  )}
                  name="contactType"
                  control={control}
                />
              </FormControl>
              <FormHelperText style={{color: 'red'}} variant="outlined">
                {errors.contactType?.message ? errors.contactType.message : ''}
              </FormHelperText>
            </div>
            <div className="col-md-4  col-sm-6  form-group">
              <Controller
                render={({value, onChange}) => (
                  <TextField
                    className={` ${classes.labelName} ${classes.inputLabel}`}
                    placeholder="Enter Name"
                    margin="dense"
                    name="contactName"
                    variant="outlined"
                    label="Name"
                    value={value}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) => {
                      onChange(e.target.value);
                      setValue('contactName', e.target.value);
                    }}
                    required
                    error={errors && errors?.contactName?.message}
                    fullWidth
                  />
                )}
                control={control}
                name="contactName"
              />
              <FormHelperText style={{color: 'red'}} variant="outlined">
                {errors.contactName?.message ? errors.contactName.message : ''}
              </FormHelperText>
            </div>
            <div className="col-md-4  col-sm-6 form-group">
              <TextField
                className={` ${classes.labelName} ${classes.inputLabel}`}
                placeholder="Enter E-Mail Address"
                margin="dense"
                name="contactEmailAddress"
                variant="outlined"
                label="E-Mail Address"
                required
                error={errors && errors?.contactEmailAddress?.message}
                InputLabelProps={{
                  shrink: true,
                }}
                inputRef={register}
                fullWidth
              />
              <FormHelperText style={{color: 'red'}} variant="outlined">
                {errors.contactEmailAddress?.message ? errors.contactEmailAddress.message : ''}
              </FormHelperText>
            </div>
            <div className="col-md-4  col-sm-6 form-group">
              <Controller
                render={({value, onChange}) => (
                  <TextField
                    className={` ${classes.labelName} ${classes.inputLabel}`}
                    placeholder="Enter Phone Number"
                    margin="dense"
                    name="contactPhoneNumber"
                    variant="outlined"
                    label="Phone Number"
                    value={value}
                    onChange={(e) => {
                      onChange(e.target.value);
                      setValue('contactPhoneNumber', e.target.value);
                    }}
                    error={errors && errors.contactPhoneNumber?.message}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    InputProps={{
                      inputComponent: PhoneMaskCustom,
                    }}
                  />
                )}
                control={control}
                name="contactPhoneNumber"
              />
              <FormHelperText style={{color: 'red'}} variant="outlined">
                {errors.contactPhoneNumber?.message ? errors.contactPhoneNumber.message : ''}
              </FormHelperText>
            </div>
            <div className="col-md-4  col-sm-6 form-group">
              <Controller
                render={({value, onChange}) => (
                  <TextField
                    className={` ${classes.labelName} ${classes.inputLabel}`}
                    placeholder="Enter Fax Number"
                    margin="dense"
                    name="contactFaxNumber"
                    variant="outlined"
                    label="Fax Number"
                    error={errors && errors.contactFaxNumber?.message}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    value={value}
                    onChange={(e) => {
                      onChange(e.target.value);
                      setValue('contactFaxNumber', e.target.value);
                    }}
                    InputProps={{
                      inputComponent: PhoneMaskCustom,
                    }}
                  />
                )}
                control={control}
                name="contactFaxNumber"
              />
              <FormHelperText style={{color: 'red'}} variant="outlined">
                {errors.contactFaxNumber?.message ? errors.contactFaxNumber.message : ''}
              </FormHelperText>
            </div>
          </div>
        </div>

        <div className="button-spacing-mb">
          <Button
            type="button"
            variant="contained"
            className={`mx-1 ${classes.buttonRoot}`}
            onClick={() => reset(initialValues)}
          >
              Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            className={`themeing-buttons mx-1 ${classes.buttonRoot}`}
            disabled={isLoading}
          >
              Add
          </Button>
        </div>

      </form>
      {isLoading && <PageLoader />}
    </div>
  );
};

export default ClientContactForm;
